import { render, staticRenderFns } from "./ChatCofenReport.vue?vue&type=template&id=21076cc6"
import script from "./ChatCofenReport.vue?vue&type=script&lang=js"
export * from "./ChatCofenReport.vue?vue&type=script&lang=js"
import style0 from "./ChatCofenReport.vue?vue&type=style&index=0&id=21076cc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports